import {
  Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, ModalProps, useDisclosure,
} from "@chakra-ui/react";
import { TaskActionContext, useTaskActionContext } from "contexts/TaskActionContext";
import { PropsWithChildren, useEffect, useMemo } from "react";
import { TaskTemplate } from "features/Resources/TaskTemplate/models";
import { UseFormReturn } from "react-hook-form";
import { PrimaryButton } from "components/Button";
import TaskActionPill from "./TaskActionPill";

export interface TaskTemplateActionButtonParentProps {
  taskTemplate: TaskTemplate;
  form?: UseFormReturn<TaskTemplate>
  autoOpen: boolean;
  setAutoOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onRemove: () => void;
}

interface TemplateTaskActionButtonProps extends PropsWithChildren {
  buttonText: string;
  buttonTitle?: string;
  autoOpen?: boolean;
  onRemove: () => void;
  modalSize?: ModalProps["size"];
}

export function TemplateTaskActionButton({
  buttonText,
  buttonTitle,
  modalSize = "xl",
  autoOpen = false,
  onRemove,
  children,
}: TemplateTaskActionButtonProps) {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const contextValue = useMemo(() => ({ onClose }), [onClose]);

  useEffect(() => {
    if (autoOpen) onOpen();
  }, [autoOpen, onOpen]);

  return (
    <>
      <TaskActionPill label={buttonText} onClick={onOpen} onRemove={onRemove} />

      <Modal isOpen={isOpen} onClose={onClose} size={modalSize}>
        <ModalOverlay />
        <ModalContent>
          {buttonTitle && <ModalHeader>{buttonTitle}</ModalHeader>}
          <ModalBody>
            <TaskActionContext.Provider value={contextValue}>
              {children}
            </TaskActionContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export interface PrebuitTaskTemplateActionButtonParentProps {
  prebuiltTaskTemplate: TaskTemplate;
}

interface PrebuiltTemplateTaskActionButtonProps extends PropsWithChildren {
  buttonText: string;
  buttonTitle?: string;
  modalSize?: ModalProps["size"];
}

export function PrebuiltTemplateTaskActionButton({
  buttonText,
  buttonTitle,
  modalSize = "xl",
  children,
}: PrebuiltTemplateTaskActionButtonProps) {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const contextValue = useMemo(() => ({ onClose }), [onClose]);

  return (
    <>
      <TaskActionPill label={buttonText} onClick={onOpen} />

      <Modal isOpen={isOpen} onClose={onClose} size={modalSize}>
        <ModalOverlay />
        <ModalContent>
          {buttonTitle && <ModalHeader>{buttonTitle}</ModalHeader>}
          <ModalBody>
            <TaskActionContext.Provider value={contextValue}>
              {children}
            </TaskActionContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export function TemplateTaskActionCloseButton() {
  const { onClose } = useTaskActionContext();
  return (
    <Flex w="100%" justifyContent="flex-end">
      <PrimaryButton onClick={onClose}>Close</PrimaryButton>
    </Flex>
  );
}
